<template>
  <ClientOnly>
    <ul class="ourClientsIcons row">
      <li
        v-for="item in filteringClients"
        :key="item.id"
        class="ourClientsIcons__item icon-clients font-light"
        :class="[`icon-logo icon-logo-${item.id}`, props.isReview ? item.classes : {'hide-on-small-only': !item.important || !props.dynamics}]"
        :title="item.title"
      >
      </li>
    </ul>
  </ClientOnly>
</template>

<script setup>
const ourClients = [
  {
    title: 'AMC',
    id: 'amc',
    important: true,
    classes: ''
  },
  {
    title: 'American Crew',
    id: 'american-crew',
    important: true,
    classes: ''
  },
  {
    title: 'Baxter International',
    id: 'baxter',
    important: true,
    classes: ''
  },
  {
    title: 'Benchmade Knife Company',
    id: 'benchmade',
    important: false,
    classes: ''
  },
  {
    title: 'Bentley Motors Limited',
    id: 'bentley',
    important: false,
    classes: ''
  },
  {
    title: 'Compass',
    id: 'compass',
    important: true,
    classes: ''
  },
  {
    title: 'CSX Corporation',
    id: 'csx',
    important: true,
    classes: ''
  },
  {
    title: 'Duraflame',
    id: 'duraflame',
    important: false,
    classes: ''
  },
  {
    title: 'Fiat',
    id: 'fiat',
    important: false,
    classes: ''
  },
  {
    title: 'Gatorade',
    id: 'gatorade',
    important: false,
    classes: ''
  },
  {
    title: 'Google',
    id: 'google',
    important: true,
    classes: ''
  },
  {
    title: 'Gulfstream',
    id: 'gulfstream',
    important: true,
    classes: ''
  },
  {
    title: 'Havas Worldwide',
    id: 'havas',
    important: false,
    classes: ''
  },
  {
    title: 'HBO',
    id: 'hbo',
    important: true,
    classes: ''
  },
  {
    title: 'Harley-Davidson Motorcycles',
    id: 'harley-davidson',
    important: false,
    classes: ''
  },
  {
    title: 'JCB',
    id: 'jcb',
    important: true,
    classes: ''
  },
  {
    title: 'KTM Racing',
    id: 'ktm',
    important: false,
    classes: ''
  },
  {
    title: 'Mattel',
    id: 'mattel',
    important: false,
    classes: ''
  },
  {
    title: 'Microsoft',
    id: 'microsoft',
    important: true,
    classes: ''
  },
  {
    title: 'Heineken International',
    id: 'heineken',
    important: false,
    classes: ''
  },
  {
    title: 'New Balance',
    id: 'new-balance',
    important: true,
    classes: ''
  },
  {
    title: 'Nike',
    id: 'nike',
    important: true,
    classes: ''
  },
  {
    title: 'Mazda',
    id: 'mazda',
    important: false,
    classes: ''
  },
  {
    title: 'Mini Cooper',
    id: 'mini',
    important: false,
    classes: ''
  },
  {
    title: 'Motorola',
    id: 'motorola',
    important: true,
    classes: ''
  },
  {
    title: 'Pennzoil-Quaker State',
    id: 'pennzoil',
    important: false,
    classes: ''
  },
  {
    title: 'Puma',
    id: 'puma',
    important: false,
    classes: ''
  },
  {
    title: 'Roland',
    id: 'roland',
    important: false,
    classes: ''
  },
  {
    title: 'Starz Inc.',
    id: 'starz',
    important: false,
    classes: ''
  },
  {
    title: 'Taco Bell',
    id: 'taco-bell',
    important: false,
    classes: ''
  },
  {
    title: 'Tesla',
    id: 'tesla',
    important: true,
    classes: ''
  },
  {
    title: 'Tiffany Co.',
    id: 'tiffany',
    important: false,
    classes: ''
  },
  {
    title: 'Thomson Reuters',
    id: 'thomson-reuters',
    important: false,
    classes: ''
  },
  {
    title: 'Twitter',
    id: 'twitter',
    important: true,
    classes: ''
  },
  {
    title: 'United Nations',
    id: 'united-nations',
    important: false,
    classes: ''
  }
]

/**
* Props
*/
const props = defineProps({
  clientsShowOnly: {
    type: [Array],
    default: null
  },
  isReview: {
    type: [Boolean],
    default: false
  },
  dynamics: {
    type: [Boolean],
    default: false
  },
  randomCount: {
    type: [Number],
    default: 5
  }
})

/**
* Active Clients
*/
const filteringClients = computed({
  get () {
    const filtering = []
    if (props.clientsShowOnly && props.clientsShowOnly.length) {
      for (const i in props.clientsShowOnly) {
        if (ourClients.find(n => n.id === props.clientsShowOnly[i].id)) {
          ourClients.find(n => n.id === props.clientsShowOnly[i].id).classes = props.clientsShowOnly.find(n => n.id === props.clientsShowOnly[i].id).classes
          filtering.push(ourClients.find(n => n.id === props.clientsShowOnly[i].id))
        }
      }

      return filtering
    } else if (props.dynamics) {
      const count = props.randomCount ? props.randomCount : 5

      while (filtering.length < count) {
        const randomIndex = Math.floor(Math.random() * ourClients.length)
        const randomElement = ourClients[randomIndex]
        if (!filtering.includes(randomElement)) {
          filtering.push(randomElement)
        }
      }

      return filtering
    }

    return ourClients
  }
})
</script>

<style lang="scss">
/*
* Styles
*/
.ourClientsIcons {
  margin-top: 0;
  margin-right: -.625rem;
  margin-left: -.625rem;
  &__item {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    width: 33%;
    min-width: 33%;
    max-width: 50%;
    height: 5rem;
    padding: .625rem 0;
    margin: 0 auto;
    color: color("primary-color", "base-2");
    text-align: center;
    list-style: none;
    transition: all .3s;
    opacity: .45;
    @media only screen and (min-width: 601px) {
      min-width: calc(100% / 4);
      max-width: 25%;
    }
    @media only screen and (min-width: 993px) {
      min-width: calc(100% / 8);
      max-width: 12.5%;
    }
    &:hover {
      opacity: .75;
    }
    &.icon-clients {
      & > span {
        display: block;
        overflow: hidden;
        width: 0;
        height: 0;
        text-indent: 100%;
      }
      &:before {
        height: 3rem;
        font-size: 3rem;
        @media only screen and (min-width: 768px) {
          font-size: 2rem;
        }
      }
    }
  }
}
</style>
